const dataExclude = [
  "Puši",
  "Kurac",
  "Kurec",
  "Kurc",
  "Kurčevo",
  "Fafanje",
  "Fafati",
  "Skurcati",
  "Sranje",
  "Zasral",
  "Posral",
  "Drekač",
  "Drek",
  "Seronja",
  "serji",
  "seri",
  "Anal",
  "Analno",
  "Sodomija",
  "Pornič",
  "Porno",
  "Pornografija",
  "Pizda",
  "Pizdun",
  "Pezde",
  "Popizdi",
  "Napizdi",
  "Razpizdi",
  "Dopizdi",
  "Odpizdi",
  "Pizdarija",
  "Pizdin",
  "Pička",
  "Pičkin",
  "Prasica",
  "Prasec",
  "Prase",
  "Kurba",
  "Kurbin sin",
  "Kurbir",
  "Kurbišče",
  "Kurbarstvo",
  "Kurbarija",
  "Kurva",
  "Jebem ti",
  "Jebi se",
  "Jeba",
  "Jebač",
  "Jebiveter",
  "Jebanje",
  "Jebeno",
  "Jebati",
  "Odjebati",
  "Najebati",
  "Zajebati",
  "Zjeban",
  "Šlatanje",
  "Šlatati",
  "Črnuh",
  "Čefur",
  "Limka",
  "Gaser",
  "Peder",
  "Debil",
  "Idiot",
  "Kreten",
  "Fak",
  "Fukati",
  "Fukanje",
  "Pofukan",
  "Prfuknjen",
  "Fuknjen",
  "Seks",
  "Seksi",
  "Seksanje",
  "Seksati",
  "Alkohol",
  "Droge",
  "Vino",
  "Pivo",
  "Viski",
  "Vodka",
  "Gin",
  "Rum",
  "Liker",
  "Tekila",
  "Marihuana",
  "LSD",
  "Cid",
  "Psilocibin",
  "Ketamin",
  "Psihadeliki",
  "Halucinogen",
  "Ekstazi",
  "MDMA",
  "Speed",
  "spid",
  "Heroin",
  "Kokain",
  "Snifanje",
  "Dildo",
  "Vibrator",
  "Otipavanje",
  "Otipavati",
  "Kurac",
  "Puši",
  "Puši kurac",
  "Kurac ",
  "Kurac ",
  "Kurčevo ",
  "Pušenje",
  "Pušiti ",
  "Sjebati ",
  "Sranje",
  "Zasrao",
  "Posrao ",
  "Strahopizdec",
  "Govno ",
  "Seronja",
  "Ne seri",
  "Čmar",
  "Analno",
  "Sodomija ",
  "Pornić",
  "Porno",
  "Pornografija ",
  "Pizda",
  "Pizdun",
  "Pičke",
  "Popizdi",
  "Napizdi",
  "Raspizdi",
  "Dopizdi",
  "Odjebi ",
  "Pizdarija",
  "Pizdin ",
  "Pička",
  "Pičkin ",
  "Svinja",
  "Prasac ",
  "Prase ",
  "Kurva",
  "Kurvin sin",
  "Kurviš",
  "Kupleraj",
  "Kurveraj",
  "Kurvanje",
  "Kurva ",
  "Jebem ti",
  "Jebi se",
  "Ševa ",
  "Jebač",
  "Jebivjetar",
  "Jebanje",
  "Jebeno ",
  "Jebati ",
  "Odjebati ",
  "Najebati ",
  "Zajebati ",
  "Sjeban ",
  "Šlatanje",
  "Šlatati",
  "Crnac ",
  "Jugoslaven ",
  "Gaserka",
  "Gaser ",
  "Peder ",
  "Debil",
  "Idiot",
  "Kreten ",
  "Fuck ",
  "Fukati",
  "Fukanje",
  "Pofukan ",
  "Sjeban ",
  "Ujeban ",
  "Seks",
  "Seksi ",
  "Seksanje",
  "Seksati",
  "Alkohol",
  "Droge",
  "Vino",
  "Pivo",
  "Viski",
  "Votka",
  "Džin",
  "Rum",
  "Liker",
  "Tekila ",
  "Marihuana",
  "LSD",
  "Cid",
  "Psilocibin ",
  "Ketamin",
  "Psihodelici",
  "Halucinogen",
  "Ecstasy",
  "MDMA",
  "Speed",
  "Heroin",
  "Kokain",
  "Snifanje",
  "Dildo",
  "Vibrator",
  "Pipkanje ",
  "Pipkati ",
  "cigarete",
  "govno",
  "Ukrajina",
  "Javelin",
  "dron Bayraktar",
  "mesar",
  "salamoreznica",
  "ubojica",
  "rasparano lice",
  "droge",
  "proljev",
  "prdac",
  "pištolj",
  "WC školjka",
  "Vape",
  "Penis",
  "prsa",
  "puši kurac",
"Kurac ",
"Klinac ",
"Kurčevo ",
"Fafanje",
"Fafati ",
"Skurcati ",
"Sranje",
"Zasrao",
"Posrao ",
"Govnar",
"Govno ",
"Seronja",
"Ne seri/seri",
"Anal",
"Analno",
"Sodomija ",
"Pornić",
"Porno",
"Pornografija ",
"Pizda",
"Pizdun",
"Pizdek",
"Popizdi",
"Napizdi",
"Raspizdi",
"Dopizdi",
"Otpizdi ",
"Pizdarija",
"Pizdin ",
"Pička",
"Pičkin ",
"Krmača",
"Krmak ",
"Svinja ",
"Kurva",
"Kurvin sin",
"Kurvar",
"Kupleraj",
"Kurvarstvo",
"Kurvarluk",
"Kurva ",
"Jebem ti",
"Jebi se",
"Zajeb ",
"Jebač",
"Jebivjetar",
"Jebanje",
"Jebeno ",
"Jebati ",
"Odjebati ",
"Najebati ",
"Zajebati ",
"Sjeban ",
"Fatanje",
"Fatati",
"Crnčuga ",
"Čifut ",
"Kičerica",
"Seljober ",
"Peder ",
"Debil",
"Idiot",
"Kreten ",
"Fak ",
"Fukati",
"Fukanje",
"Izjeban ",
"Opičen ",
"Ćaknut ",
"Seks",
"Seksi ",
"Seksanje",
"Seksati se",
"Alkohol",
"Droge",
"Vino",
"Pivo",
"Viski",
"Votka",
"Džin",
"Rum",
"Liker",
"Tekila ",
"Marihuana",
"LSD",
"Cid",
"Psilocibin ",
"Ketamin",
"Psihadelici",
"Halucinogen",
"Ekstazi",
"MDMA",
"Speed/spid",
"Heroin",
"Kokain",
"Snifanje",
"Dildo",
"Vibrator",
"Opipavanje ",
"Opipavati ",
"cigarete",
"kakica",
"Ukrajina",
"Javelin",
"dron Bayraktar",
"mesar",
"salamoreznica",
"ubica",
"rasparano lice",
"droge",
"proljev",
"prdež",
"pištolj",
"WC-šolja",
"Vape",
"Penis",
"grudi",
"Debeli",
"Smrad",
"Svinja",
"Đubre",
"Đubrivo",
"Đubreni",
"Zajebant",
"Zajeban",
"Izjebani",
"Sjeban",
"Zafrkavati",
"Sramota",
"Budala",
"Odvratan",
"Cigan",
"Pičkica",
"Ćuna",
"Ćunica",
"Piša",
"Pišica",
"Guzica",
"Guza",
"zadnjica",
"izjebat",
"PM",
"Idi u tri PM",
"Marš u tri PM",
"Nevaljao",
"Nevaljala",
"bale",
"sline",
"Božić",
"Djed Božićnjak",
"Advent",
"Spar",
"Mercator",
"Hofer",
"Tuš",
"Eurospin",
"E.Leclerc",
"DM",
"MÜLLER",
"Schwanz (lutschen)",
"Schwanz ",
"Schwanz ",
"beschissen ",
"Blasen",
"blasen ",
"jemanden fertigmachen ",
"Scheiße",
"verkackt",
"versaut ",
"Scheißkerl",
"Scheiße ",
"Arschloch",
"Laber keinen Scheiß",
"anal",
"anal",
"Sodomie ",
"Pornofilm",
"Porno",
"Pornografie ",
"Fotze",
"Wichser",
"Dreckskerl",
"ausrasten",
"jemanden anpissen",
"jemanden auf die Palme bringen",
"auf den Sack gehen",
"verpiss dich ",
"Scheißdreck",
"fotzig ",
"Muschi",
"muschihaft ",
"Sau",
"Schwein ",
"Schwein ",
"Hure",
"Hurensohn",
"Freier",
"Bordell",
"Hurerei",
"Hurenkram",
"Hure ",
"Fick dich",
"Verpiss dich",
"Scheißsituation ",
"Ficker",
"Nichtsnutz",
"Ficken",
"verdammt ",
"ficken ",
"abwimmeln ",
"drankriegen ",
"verkacken ",
"kaputt ",
"Grapschen",
"begrapschen",
"Neger ",
"Kanake ",
"Schlampe",
"Proll ",
"Schwuchtel ",
"Idiot",
"Idiot",
"Arschloch ",
"Fuck ",
"ficken",
"Ficken",
"durchgefickt ",
"durchgeknallt ",
"durchgeknallt ",
"Sex",
"sexy ",
"Sex haben",
"Sex haben",
"Alkohol",
"Drogen",
"Wein",
"Bier",
"Whisky",
"Wodka",
"Gin",
"Rum",
"Likör",
"Tequila ",
"Marihuana",
"LSD",
"Acid",
"Psilocybin ",
"Ketamin",
"Psychedelika",
"Halluzinogen",
"Ecstasy",
"MDMA",
"Speed",
"Heroin",
"Kokain",
"Koks ziehen",
"Dildo",
"Vibrator",
"antatschen ",
"antatschen ",
"Zigaretten",
"Kacke",
"Ukraine",
"Javelin-Rakete",
"Bayraktar-Drohne",
"Metzger",
"Aufschnittmaschine",
"Mörder",
"aufgeschlitztes Gesicht",
"Drogen",
"Durchfall",
"Furz",
"Pistole",
"Toilettenschüssel",
"E-Zigarette",
"Penis",
"Brüste",
"Fettsack",
"Stinker",
"Schwein",
"Eiter",
"Gülle",
"eitrig",
"Witzbold",
"kompliziert",
"durchgefickt",
"durchgeknallter Typ",
"verarschen",
"Schande",
"Dummkopf",
"widerlich",
"Zigeuner",
"zickig",
"Pimmel",
"Pimmelchen",
"Pimmel",
"Pimmelchen",
"Arsch",
"Popo",
"Gesäß",
"durchficken",
"Scheiße",
"Geh zum Teufel",
"Zum Teufel mit dir",
"unanständig",
"unanständig",
"Rotznase",
"Rotznase",
"Weihnachten",
"Weihnachtsmann",
"Advent",
"Rewe",
"Hit",
"Edeka",
"Netto",
"Lidl",
"Kaufland",
"Norma",
"Penny "

];

export { dataExclude };
